import { flexWorkerService } from 'hq/services';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetFlexWorkerProfile = (flexWorkerId: string) => {
  const queryFn = async () => await flexWorkerService.getFlexWorkerProfile(flexWorkerId);

  return useQuery(QUERY_KEYS.flexWorkerProfile(flexWorkerId), queryFn);
};
